/**
 * PieChartEditor
 *
 * Property editor for pie/doughnut chart configuration
 */

import React from 'react';
import { ChartBaseEditor, type ChartBaseConfig } from './ChartBaseEditor';
import { SelectPropertyEditor } from '../../BaseEditors/SelectPropertyEditor';
import { NumberPropertyEditor } from '../../BaseEditors/NumberPropertyEditor';

export interface PieChartEditorProps {
  config: Partial<ChartBaseConfig & {
    innerRadius?: number;
    startAngle?: number;
    endAngle?: number;
    showLabels?: boolean;
  }>;
  onChange: (config: Partial<ChartBaseConfig>) => void;
}

export const PieChartEditor: React.FC<PieChartEditorProps> = ({ config, onChange }) => {
  return (
    <ChartBaseEditor config={config} onChange={onChange} chartType="Pie Chart" showAxes={false}>
      <div className="chart-editor__section">
        <h3 className="chart-editor__section-title">Pie Chart Options</h3>

        <NumberPropertyEditor
          label="Inner Radius (0 = Pie, >0 = Doughnut)"
          value={(config.innerRadius as number) || 0}
          onChange={(innerRadius) => onChange({ ...config, innerRadius })}
          min={0}
          max={100}
          step={5}
          helpText="% of radius for doughnut hole"
          suffix="%"
        />

        <NumberPropertyEditor
          label="Start Angle (degrees)"
          value={(config.startAngle as number) || 0}
          onChange={(startAngle) => onChange({ ...config, startAngle })}
          min={0}
          max={360}
          step={15}
        />

        <NumberPropertyEditor
          label="End Angle (degrees)"
          value={(config.endAngle as number) || 360}
          onChange={(endAngle) => onChange({ ...config, endAngle })}
          min={0}
          max={360}
          step={15}
        />

        <div className="chart-editor__checkbox">
          <input
            type="checkbox"
            id="show-labels"
            checked={config.showLabels !== false}
            onChange={(e) => onChange({ ...config, showLabels: e.target.checked })}
            className="af-property-editor__checkbox"
          />
          <label htmlFor="show-labels" className="af-property-editor__label">
            Show Percentage Labels
          </label>
        </div>
      </div>
    </ChartBaseEditor>
  );
};

PieChartEditor.displayName = 'PieChartEditor';
